import { createWebSupportContactEventFactory } from '@spotify-internal/ubi-sdk-support-spotify-com-web-support-contact';
import { useMemo } from 'react';

import { PageId } from 'utils/ubi/pageId';

import { useUbiPage } from '../useUbiPage';
import { useUbiContext } from '../ubiProvider';

const pageId = PageId.Contact;

export const useUbiContactPage = () => {
  const ubiLogger = useUbiContext();
  const { pageFactory } = useUbiPage(pageId, '', createWebSupportContactEventFactory);
  return useMemo(
    () => ({
      logEmailTextLinkImpression: () => ubiLogger.logImpression(pageFactory.mailtoTextLinkFactory().impression()),
      logEmailButtonLinkImpression: () => ubiLogger.logImpression(pageFactory.mailtoButtonLinkFactory().impression()),
      logStartMessagingButtonImpression: () =>
        ubiLogger.logImpression(pageFactory.startMessagingButtonFactory().impression()),
      // TODO: This is not possible right now as the link is embedded in translated content.
      // logEmailTextLinkInteraction: (destination: string) =>
      //   ubiLogger.logInteraction(pageFactory.mailtoTextLinkFactory().hitNavigateToExternalUri({ destination })),
      logEmailButtonLinkInteraction: (destination: string) =>
        ubiLogger.logInteraction(pageFactory.mailtoButtonLinkFactory().hitNavigateToExternalUri({ destination })),
      logStartMessagingButtonInteraction: () =>
        ubiLogger.logInteraction(pageFactory.startMessagingButtonFactory().hitUiReveal()),
    }),
    [pageFactory, ubiLogger],
  );
};

export type UbiContactPage = ReturnType<typeof useUbiContactPage>;
